import { createContext, useContext, useMemo, useState, useCallback } from 'react'

export const FilterContext = createContext(null)

const emptyFilters = {
  grupo: [], cargo: [], fundo: [], regime: [], grupo_evento: [], evento: [], situacao: [], secretaria: []
}

export function FilterProvider({ children }) {
  const [monthYear, setMonthYear] = useState('') // YYYY-MM

  // Filtros pendentes (selecionados pelo usuário, mas ainda não aplicados)
  const [pendingFilters, setPendingFilters] = useState(emptyFilters)

  // Filtros aplicados (usados nas consultas ao backend)
  const [appliedFilters, setAppliedFilters] = useState(emptyFilters)

  const [indicator, setIndicator] = useState('net') // 'gross' | 'net' | 'avg_gross' | 'avg_net'

  // Aplica os filtros pendentes
  const applyFilters = useCallback(() => {
    setAppliedFilters({ ...pendingFilters })
  }, [pendingFilters])

  // Limpa todos os filtros
  const clearFilters = useCallback(() => {
    setPendingFilters(emptyFilters)
    setAppliedFilters(emptyFilters)
  }, [])

  // Verifica se há filtros pendentes não aplicados
  const hasUnappliedChanges = useMemo(() => {
    return JSON.stringify(pendingFilters) !== JSON.stringify(appliedFilters)
  }, [pendingFilters, appliedFilters])

  const value = useMemo(() => ({
    monthYear, setMonthYear,

    // Filtros pendentes (para os componentes de seleção)
    pendingFilters,
    setPendingFilters,

    // Filtros aplicados (para as queries)
    appliedFilters,

    // Ações
    applyFilters,
    clearFilters,
    hasUnappliedChanges,

    // Indicador
    indicator,
    setIndicator,

    // Mantém compatibilidade com código antigo
    filters: appliedFilters,
    setFilters: setPendingFilters,
  }), [monthYear, pendingFilters, appliedFilters, indicator, applyFilters, clearFilters, hasUnappliedChanges])

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  )
}

export function useGlobalFilters() {
  const ctx = useContext(FilterContext)
  if (!ctx) throw new Error('useGlobalFilters must be used within FilterProvider')
  return ctx
}
